export default __webpack_public_path__ + "static/media/add_resource_url.22547dad.png";